import _defineProperty from "@babel/runtime/helpers/defineProperty";
class Deferred {
  constructor() {
    _defineProperty(this, "promise", void 0);
    _defineProperty(this, "reject", void 0);
    _defineProperty(this, "resolve", void 0);
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
}
export default class ItemsDimensionsHelper {
  constructor() {
    _defineProperty(this, "itemDimensionsCache", {});
    _defineProperty(this, "itemsDimensions", {});
    _defineProperty(this, "preloadedItems", {});
  }
  preloadItem(item, onload) {
    if (!item || !item.itemId || !item.mediaUrl) {
      return;
    }
    try {
      const id = item.itemId;
      if (this.itemsDimensions[id]) {
        return; // already measured
      }
      if (typeof this.preloadedItems[id] !== 'undefined') {
        return;
      }
      this.preloadedItems[id] = new Image();
      this.preloadedItems[id].src = item.mediaUrl;
      if (typeof onload === 'function') {
        this.preloadedItems[id].onload = e => {
          onload(e);
        };
      }
      return this.preloadedItems[id];
    } catch (e) {
      console.error('Could not preload item', item, e);
      return;
    }
  }
  addSentDimensionsToCache(itemDimensions) {
    itemDimensions.forEach(dimensions => {
      this.itemDimensionsCache[dimensions.mediaUrl] = dimensions;
    });
  }
  isDimensionless(item) {
    try {
      if (!item.metaData.height || !item.metaData.width) {
        return true;
      }
      if (item.metaData.height <= 1 || item.metaData.width <= 1) {
        return true;
      }
    } catch (e) {
      console.error('corrupt item, cant check for dimensions', item, e);
    }
    return false;
  }
  isSSR() {
    try {
      return !window;
    } catch (e) {
      return true;
    }
  }
  loadItemsDimensionsIfNeeded(items, callback) {
    if (this.isSSR()) {
      return;
    }
    if (!(items && items.length > 0)) {
      return;
    }
    const itemsWithoutDimensions = items.filter(item => {
      try {
        return !this.itemDimensionsCache[item.mediaUrl] && this.isDimensionless(item);
      } catch (e) {
        return false;
      }
    });
    if (!itemsWithoutDimensions.length) {
      return;
    }
    const itemPromises = itemsWithoutDimensions.map(() => {
      return new Deferred();
    });
    itemsWithoutDimensions.forEach((item, idx) => {
      const itemPromise = itemPromises[idx];
      this.preloadItem(item, e => {
        try {
          const ele = e.srcElement;
          const itemId = item.itemId;
          const mediaUrl = item.mediaUrl;
          const itemDim = {
            width: ele.width,
            height: ele.height,
            measured: true,
            itemId,
            mediaUrl
          };
          this.itemsDimensions[itemId] = itemDim;
          itemPromise.resolve(this.itemsDimensions[itemId]);
        } catch (_e) {
          console.error('Could not calc element dimensions', _e);
        }
      });
    });
    Promise.all(itemPromises.map(deffered => deffered.promise)).then(itemDimensions => {
      this.addSentDimensionsToCache(itemDimensions);
      const itemsWithDims = items.map(item => this.addDimensionsFromCache(item));
      callback(itemsWithDims);
    });
  }
  addDimensionsFromCache(item) {
    const dimensions = this.itemDimensionsCache[item.mediaUrl];
    if (dimensions) {
      return {
        ...item,
        metaData: {
          ...item.metaData,
          width: dimensions.width,
          height: dimensions.height
        },
        measured: true
      };
    }
    return null;
  }
}
//# sourceMappingURL=itemsDimensionsHelper.js.map